<div class="app-networking-list">
    <h1 class="col-9 col-md-9 fs-18 pl-0 network-header">Networking</h1>
    <div class="mb-15 text-center" *ngIf="rooms && rooms?.length == 0">
        No records found
    </div>
      <div class="row align-items-center justify-content-center">
        <div class="col-12 col-md-7 ">
            <div id="myCarousel" class="carousel text-center slide mb-20" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <ng-container *ngIf="streamAds && eventHomeAdsTop && eventHomeAdsTop.length > 0 ">
                        <div *ngFor="let a of eventHomeAdsTop; let i=index" class="adv-img1 carousel-item"
                            id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                        </div>
                        <div class="ad-position">
                            <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1" ></i></a></span> 
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
       
    </div>
    <div class="row">
        <div class="col-12 col-sm-11 col-md-10 mb-4 ">
            <div class="list">
                <ng-container *ngIf="rooms && rooms?.length > 0">
                    <div class="room-container">
                        <div class="row">
                            <div class="col-12 col-md-3 pointer" *ngFor="let room of rooms">
        
                                <div class="box-style p-20">
                                    <div class="row no-gutters">
                                        <!-- <div class="col-12">
                                            <p class="fs-20" *ngIf="room?.name && room?.name.length <= 50"> {{room?.name}} </p>
                                            <p *ngIf="room?.name && room?.name.length > 50" matTooltipPosition="above"
                                                matTooltip="{{room.name}}">
                                                {{room?.name | slice: 0:50}}
                                                {{room?.name.length > 50 ? "..." : ""}}
                                            </p>
                                            <p *ngIf="room?.description && room?.description.length <= 125">
                                                {{room?.description}}
                                            </p>
                                            <p *ngIf="room?.description && room?.description.length > 125"
                                                matTooltipPosition="above" matTooltip="{{room.description}}">
                                                {{room?.description | slice: 0:125}}
                                                {{room?.description.length > 125 ? "..." : ""}}
                                            </p>
                                        </div> -->
                                        <div class="col-12">
                                            <p class="fs-20 line-clamp" matTooltipPosition="above"
                                            matTooltip="{{room.name}}"> {{room?.name}} </p>
                                            <!-- <p *ngIf="room?.name && room?.name.length > 50" matTooltipPosition="above"
                                                matTooltip="{{room.name}}">
                                                {{room?.name | slice: 0:50}}
                                                {{room?.name.length > 50 ? "..." : ""}}
                                            </p> -->
                                            <p class="line-clamp"  matTooltipPosition="above" matTooltip="{{room.description}}">
                                                {{room?.description}}
                                            </p>
                                            <!-- <p *ngIf="room?.description && room?.description.length > 125"
                                                matTooltipPosition="above" matTooltip="{{room.description}}">
                                                {{room?.description | slice: 0:125}}
                                                {{room?.description.length > 125 ? "..." : ""}}
                                            </p> -->
                                        </div>
                                        <div class="col-12 text-right join-btn">
                                            <button (click)="goToTickets()" *ngIf="!room?.isPurchased" mat-flat-button
                                                class="btn flat-primary-button primary-bg-button">
                                                Get Ticket</button>
                                            <span *ngIf="room?.isPurchased"
                                                [matTooltip]="(room.usersCount>=room.persons_allowed)?'Room is full': (room.room_status != 1 && room.host_manage_subroom==1) ? 'Please wait for the host to start':''"
                                                matTooltipPosition="above">
                                                <button
                                                    (click)="(!isPubNubChannelAvailable)?connectPubNubChannels(room):joinRoom(room)"
                                                    [disabled]="room.usersCount>=room.persons_allowed || (room.host_manage_subroom==1 && room.room_status==0)"
                                                    mat-flat-button class="btn flat-primary-button primary-bg-button">
                                                    Join</button>
                                            </span>
        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="col-12 col-sm-11 col-md-2 mb-4">    
                     <div><div class="pointer">    <div id="RightCarousel" class="carousel slide" data-ride="carousel" data-pause="hover">
            <div class="carousel-inner">
                <ng-container *ngIf="streamAds && eventHomeAdsRight && eventHomeAdsRight.length > 0">
                    <div *ngFor="let a of eventHomeAdsRight; let i=index" class="adv-img2 carousel-item"
                        id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                    </div>
                    <div class="ad-position">
                        <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1" ></i></a></span> 
                    </div>
                </ng-container>
            </div>
        </div></div></div>
    </div>
    </div>
    
</div>